import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/services/API/api.service';
import { LogBatchPayload, LoggerHttpSender } from './logger.types';

@Injectable({ providedIn: 'root' })
export class ProjectApiLoggerHttpSender implements LoggerHttpSender {
  private warned = false;
  constructor(private api: ApiService) {}

  async send(endpoint: string, payload: LogBatchPayload): Promise<void> {
    try {
      await Promise.resolve(this.api.post(endpoint, payload));
      this.warned = false;
    } catch (err) {
      if (!this.warned) {
        this.warned = true;
        console.warn('[logger] failed to ship events; further failures will be silent', err);
      }
    }
  }
}
